import { render } from "./commerciale.vue?vue&type=template&id=a5edd062"
import script from "./commerciale.vue?vue&type=script&lang=js"
export * from "./commerciale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__